/*
 *  			'License for ONE AXA SOFTWARE - Inner Source'
 * 					L O A S - I S
 * 
 * The following License aims to be applied between the AXA Companies, according to the following definition:
 * "AXA Companies" means AXA, Société Anonyme with a “AXA Companies ” Board of Directors having its principal offices at 25, avenue Matignon, 75008 Paris, registered on the Commercial Registry of Paris under the number 572 093 920; and (i) any other company controlled by, or controlling AXA, with a company being considered as controlling another: (a) when it holds directly or indirectly a portion of the capital according to it the majority of the voting rights in general meetings of shareholders of this company; (b) when it holds solely the majority of the voting rights in this company by virtue of an agreement concluded with other partners or shareholders and which is not contrary to the interest of the company; (c) when it determines de facto, by voting rights which it holds, the decisions in the general meetings of shareholders of this company; (d) in any event, when it holds, directly or indirectly, a portion of voting rights greater than 40% and when no other partner or shareholder holds directly or indirectly a portion which is greater than its own; (ii) any economic interest group in which AXA and/or one or more other Companies of the AXA Group participates for at least 50% in operating costs; (iii) in the cases where the law applicable to a company limits voting rights or control (such as defined here in above), this company will be deemed to be a company of the AXA Group, if the voting rights in 2 Binding Corporate Rules – AXA Group – version 2013 general shareholders’ meetings or the control held by a Company of the AXA Group reaches the maximum amount fixed by said applicable law; and (iv) all AXA Companies constitute the “AXA Group” (hereafter "One AXA").  (Binding Corporate Rules - AXA Group - version 2019).
 * 
 * Software credits: 
 * 	Creator: AXA GO GETD
 * 	Main contributors: AXA GO GETD
 * 
 * Permission is hereby granted, free of charge, to any person or entity within One AXA obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software within One AXA, including the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 * 
 * The above credit notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * Any improvement or modification of the Software shall be made available to the whole One AXA, under the terms of this License.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

/* eslint-disable no-unused-vars */
/*
 * Copyright (c) 2020 AXA Group Operations Spain S.A.
 *
 * Licensed under the AXA Group Operations Spain S.A. License (the "License");
 * you may not use this file except in compliance with the License.
 * A copy of the License can be found in the LICENSE.TXT file distributed
 * together with this file.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { useEffect, useState } from 'react';
import { Button, Row, Col, Form } from 'antd';
import Select from 'antd/es/select';

import { formatDateTime } from '@utils/format/dates';
import { MESSAGES } from '@translations/labels';
import { useCorpusVersionGet } from 'commons/hooks/useCorpusVersion';
import { idField } from '@constants';
import { useFlowVersionsGet } from '../../hooks/useFlowsVersion';
import { useReleaseLoad } from '../../hooks/useReleaseLoad';
import { getSummary } from './release.helper';
import pageStyles from './releaseStyles';

const labels = { ...MESSAGES.manageBot.releasesPage };

const LoadReleaseInTesterForm = () => {
  const [loadform] = Form.useForm();
  const { Option } = Select;

  const { releases } = useCorpusVersionGet();
  const flowVersionsResult = useFlowVersionsGet();
  const { loadRelease } = useReleaseLoad();
  const [currentSummary, setSummary] = useState();
  const [loadedReleaseValue, setLoadedRelease] = useState(null);

  let defaultReleaseLoaded;

  if (releases) {
    releases.some(item => {
      if (item.isActiveTraining) {
        defaultReleaseLoaded = item[idField];
        return true;
      }
      return false;
    });
    const activeCorpusTest = releases.find(r => r.isActiveTraining);
    if (activeCorpusTest && !loadform.getFieldValue('corpusReleaseToLoad')) {
      loadform.setFieldsValue({
        corpusReleaseToLoad: activeCorpusTest[idField],
      });
    }
  }

  let flowReleasesOptions = [
    {
      [idField]: 'only-nlp',
      releaseDate: '',
      releaseDescription: 'Test only the corpus',
    },
  ];

  if (flowVersionsResult.releases) {
    flowReleasesOptions = [...flowReleasesOptions, ...flowVersionsResult.releases];
    const currentFlowRelease = flowVersionsResult.releases.find(r => r.isActiveTraining);
    if (currentFlowRelease && !loadform.getFieldValue('flowReleaseToLoad')) {
      loadform.setFieldsValue({
        flowReleaseToLoad: currentFlowRelease[idField],
      });
    }
  }

  useEffect(() => {
    if (defaultReleaseLoaded) {
      console.log('setLoadedRelease -> ', defaultReleaseLoaded);
      setLoadedRelease(defaultReleaseLoaded);

      const summaryTxt = getSummary(defaultReleaseLoaded, releases);
      if (!currentSummary && summaryTxt) {
        setSummary(summaryTxt);
      }
    }
  }, [defaultReleaseLoaded]);

  const handleLoadReleaseInTesterChange = value => {
    console.log('handleLoadReleaseInTesterChange', value);
    const summaryTxt = getSummary(value, releases);
    if (summaryTxt) {
      setSummary(summaryTxt);
    }
  };

  const handleLoadReleaseInTester = values => {
    console.log('handleLoadReleaseInTester -> ', values);
    loadRelease(values.corpusReleaseToLoad, values.flowReleaseToLoad);
  };

  return (
    <Form
      name="load-release"
      onFinish={handleLoadReleaseInTester}
      form={loadform}
      initialValues={{
        corpusReleaseToLoad: loadedReleaseValue,
      }}
    >
      <header className="header-release-page">
        <h5>{labels.markToTestTitle}</h5>
      </header>
      <Row gutter={[20, 30]}>
        <Col>
          <Form.Item
            name="corpusReleaseToLoad"
            className="release-drowdown"
            rules={[
              {
                required: true,
                message: labels.formSelectReleaseMessage,
              },
            ]}
          >
            <Select
              allowClear
              placeholder={labels.formSelectReleasePlaceholder}
              onChange={handleLoadReleaseInTesterChange}
              style={{
                width: 550,
              }}
            >
              {releases.map(releaseItem => (
                <Option value={releaseItem[idField]} key={releaseItem[idField]}>
                  Corpus: ({formatDateTime(releaseItem.releaseDate)}) {releaseItem.releaseDescription}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <div className="release-summary">{currentSummary}</div>
        </Col>
        {/*
        <Col>
          <Form.Item
            name="flowReleaseToLoad"
            className="release-drowdown"
            rules={[
              {
                required: true,
                message: labels.formSelectReleaseMessage
              }
            ]}
          >
            <Select allowClear placeholder={labels.formSelectFlowReleasePlaceholder} style={{ width: 350 }}>
              {flowReleasesOptions.map(releaseItem => (
                <Option key={releaseItem[idField]} value={releaseItem[idField]}>
                  {releaseItem.releaseDate !== '' ? `Flows: (${formatDateTime(releaseItem.releaseDate)})` : ' '}{' '}
                  {releaseItem.releaseTitle}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        */}

        <Col>
          <Form.Item>
            <Button type="primary" htmlType="submit" className="uppercase release-button">
              {labels.btnLoadInTest}
            </Button>
          </Form.Item>
        </Col>
      </Row>
      <style jsx>{pageStyles}</style>
    </Form>
  );
};

export { LoadReleaseInTesterForm };
